var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMicrophoneSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.81 17.32A6.74 6.74 0 0 1 5.25 13V8c0-3.72 3.03-6.75 6.75-6.75 3.1 0 5.79 2.1 6.55 5.1.1.4-.14.81-.54.91-.39.1-.81-.14-.91-.54A5.261 5.261 0 0 0 12 2.75C9.11 2.75 6.75 5.1 6.75 8v5c0 1.23.43 2.42 1.21 3.36a.75.75 0 1 1-1.15.96zM9.66 19.33a.74.74 0 0 1-.44-.96.74.74 0 0 1 .96-.44c.58.22 1.2.33 1.82.33 2.89 0 5.25-2.35 5.25-5.25V9.98c0-.41.34-.75.75-.75s.75.34.75.75V13c0 3.72-3.03 6.75-6.75 6.75-.81 0-1.6-.14-2.34-.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35 20.13a.755.755 0 0 1-.04-1.06c.28-.3.76-.32 1.06-.04a8.203 8.203 0 0 0 5.62 2.21c4.55 0 8.25-3.7 8.25-8.25v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c.01 5.39-4.36 9.76-9.74 9.76-2.48 0-4.84-.93-6.65-2.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97 22.52a.754.754 0 0 1 0-1.06l19-19c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-19 19c-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM10.8 5.5V2.26c0-.41.34-.75.75-.75s.75.34.75.75V5.5a.749.749 0 1 1-1.5 0zM7.75 7.5v-4c0-.41.34-.75.75-.75s.75.34.75.75v4c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMicrophoneSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-microphone-slash.9ebbbccd013f2132ead349d40eff67a6.svg";
export { ForwardRef as ReactComponent };